import getters from './getters.js';

export default {
	state: {
		appName: process.env.APP_NAME,
		school: null,
		schools: null,
		academicYear: null,
		visit: {
			text: 'Selecciona una visita',
			value: 0
		},
		academicYears: null
	},
	mutations: {
		SET_SCHOOL (state, school) {
			state.school = school;
		},
		SET_SCHOOLS (state, schools) {
			state.schools = schools;
		},
		SET_ACADEMIC_YEAR (state, academicYear) {
			state.academicYear = academicYear;
		},
		SET_VISIT (state, visit) {
			state.visit = visit;
		},
		SET_ACADEMIC_YEARS (state, academicYears) {
			state.academicYears = academicYears;
		},
		CLEAR_SCHOOLS (state) {
			state.schools = null;
		},
		CLEAR_ACADEMIC_YEAR (state) {
			state.academicYear = null;
		},
		CLEAR_ACADEMIC_YEARS (state) {
			state.academicYears = null;
		},
		CLEAR_VISIT (state) {
			state.visit = null;
		}
	},
	actions: {
		setSchool (context, school) {
			context.commit('SET_SCHOOL', school);
		},

		setSchools (context, schools) {
			context.commit('SET_SCHOOLS', schools);
		},

		setAcademicYear (context, academicYear) {
			context.commit('SET_ACADEMIC_YEAR', academicYear);
		},

		setVisit (context, visit) {
			context.commit('SET_VISIT', visit);
		},

		setAcademicYears (context, academicYears) {
			context.commit('SET_ACADEMIC_YEARS', academicYears);
		},

		clearSchools (context) {
			context.commit('CLEAR_SCHOOLS');
		},

		clearAcademicYear (context) {
			context.commit('CLEAR_ACADEMIC_YEAR');
		},

		clearVisit (context) {
			context.commit('CLEAR_VISIT');
		},

		clearAcademicYears (context) {
			context.commit('CLEAR_ACADEMIC_YEARS');
		}
	},
	getters
};



// WEBPACK FOOTER //
// ./src/store/persistent/index.js